import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { MetaWhatsAppNumberPolicyPhone, WhatsAppPhoneStateColorMap } from '@/types';
import { phoneState } from '@/utils/whatsappMeta';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberEligibilityState',
  props: {
    phone: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const state = computed(() => phoneState(props.phone));

const badge = computed(() => WhatsAppPhoneStateColorMap[state.value]);

return (_ctx: any,_cache: any) => {
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createBlock(_component_UiBadge, {
    variant: badge.value.variant,
    "text-variant": badge.value.textVariant,
    size: "sm"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)(`whatsappMeta.phoneState.${state.value}`)), 1)
    ]),
    _: 1
  }, 8, ["variant", "text-variant"]))
}
}

})